import Search from './pages/Search.js';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme/theme';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

function Home() {
    return(
        <p>Change URL</p>
    )
}

function App() {
  return (
    <div className="App">
        <ThemeProvider theme={theme}>

         <BrowserRouter basename='/search'>
    <Routes>
            <Route path="/" element={<Search />} >
          <Route path=":corpus" element={<Search />} />
                </Route>
         <Route path="search/:corpus" element={<Search />} />

        <Route path="/about" element={<Home />} />


    </Routes>
  </BrowserRouter>
  </ThemeProvider>
    </div>
  );
}

export default App;
